import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotificationsService } from '../../../core/services/profile/notifications.service';


@Component({
  selector: 'app-notify-user',
  templateUrl: './bell-notify-user.component.html',
  styleUrls: ['./bell-notify-user.component.scss']
})
export class BellNotifyUserComponent implements OnInit, OnDestroy {

  notifyList;
  itemRead ;
  notifyObserver;  
  unreadAmount = 0;
  interval;

  constructor(
    private _notificationsService : NotificationsService
  ) { }

  ngOnDestroy(): void {
   clearInterval(this.interval);
  }

  ngOnInit() {

    this.notifyObserver = this._notificationsService.getObserver();
    this.notifyObserver.subscribe(
      data => {
        this.notifyList = data;
        this.unreadAmount = this.notifyList.filter( item => { return !item.readInd} ).length;        
      }
    );
    this._notificationsService.getNotifications();

    /**Se consulta la notificaciones cada 15 minutos*/
    this.interval = setInterval(()=>{
      this._notificationsService.getNotifications()}, 900000);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/bell-notify-user/bell-notify-user.component.ts